// Copyright (c) Docugami, Inc. All rights reserved.
import { SettingsActionTypes, SET_ASSISTED_AUTH_SETTINGS, AssistedAuthoringSettings, SET_SETTINGS_PANEL_SHOWING, SET_WORD_TEST_TASKPANE_SHOWING } from "./types";

export function setAssistedAuthoringSettings(state: AssistedAuthoringSettings): SettingsActionTypes
{
    return {
        type: SET_ASSISTED_AUTH_SETTINGS,
        payload: state
    };
}

export function setWordTaskpaneShowing(state: boolean): SettingsActionTypes
{
    return {
        type: SET_WORD_TEST_TASKPANE_SHOWING,
        payload: state
    };
}

export function setSettingsPanelShowing(state: boolean): SettingsActionTypes
{
    return {
        type: SET_SETTINGS_PANEL_SHOWING,
        payload: state
    };
}